exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-heart-icon-wrapper[data-v-5c56ddf1]{-ms-flex-order:2;order:2}.profile-heart-icon-wrapper[data-v-5c56ddf1]  svg{color:#fff;display:block;width:auto;height:15px}", ""]);

// exports
